export const ROW_TRUNCATE_LIMIT = 25;

export const SCHEMA_PAIR_TRUNCATE_LIMIT = 15;

export const truncate = (str, max = ROW_TRUNCATE_LIMIT) =>
    str && str.length > max ? str.slice(0, max) + '…' : str;

export const truncateUrl = (url, startChars = 24, endChars = 10) => {
    if (!url || url.length <= startChars + endChars + 1) return url;
    return `${url.slice(0, startChars)}…${url.slice(url.length - endChars)}`;
};

export const EXTERNAL_LINK_STYLE = { width: '0.729vw', height: '0.729vw', marginLeft: '0.208vw', verticalAlign: 'middle' };